<div class="skeleton-container">
  <div *ngFor="let i of arr" class="base-skeleton pulse">
    <div class="title-skt"></div>
    <div class="desc-skt"></div>
  </div>
</div>
